import API from '.';
export default class RealEstateInterestType {
  /**
   * The primaryUseType dimension table for UDM
   * @param {number} parentRealEstateInterestType
   * @param {string} realEstateInterestTypeDesc
   * @param {number} realEstateInterestTypeId
   * @param {string} realEstateInterestTypeName
   **/

  constructor({
    parentRealEstateInterestType,
    realEstateInterestTypeDesc,
    realEstateInterestTypeId,
    realEstateInterestTypeName,
  }) {
    this.parentRealEstateInterestType = parentRealEstateInterestType;
    this.realEstateInterestTypeDesc = realEstateInterestTypeDesc;
    this.realEstateInterestTypeId = realEstateInterestTypeId;
    this.realEstateInterestTypeName = realEstateInterestTypeName;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/RealEstateInterestType');
    return data.map((d) => new RealEstateInterestType(d));
  }
  static async get(id) {
    const api = await API();
    const { data } = await api.get(`RealEstateInterestType/${id}`);
    return new RealEstateInterestType(data);
  }
}
